import { Box, Image, Text } from "@chakra-ui/react";
import Marquee from "react-fast-marquee";
import visaLogo from "../assets/payment-methods/visa.png";
import mastercardLogo from "../assets/payment-methods/mastercard.png";
import americanExpressLogo from "../assets/payment-methods/american-express.png";
import discoverLogo from "../assets/payment-methods/discover.png";
import jcbLogo from "../assets/payment-methods/jcb.png";
import amazonPayLogo from "../assets/payment-methods/amazon-pay.png";
import cashAppLogo from "../assets/payment-methods/cash-app.png";
import linkLogo from "../assets/payment-methods/link-logo.png";

export const PaymentMethodsMarquee = () => {
  // Top 10 most popular payment methods
  const paymentMethods = [
    {
      name: "Visa",
      logo: visaLogo,
      type: "card",
    },
    {
      name: "Mastercard",
      logo: mastercardLogo,
      type: "card",
    },
    {
      name: "American Express",
      logo: americanExpressLogo,
      type: "card",
    },
    {
      name: "Discover",
      logo: discoverLogo,
      type: "card",
    },
    {
      name: "JCB",
      logo: jcbLogo,
      type: "card",
    },
    {
      name: "Apple Pay",
      logo: "https://upload.wikimedia.org/wikipedia/commons/b/b0/Apple_Pay_logo.svg",
      type: "wallet",
    },
    {
      name: "Google Pay",
      logo: "https://upload.wikimedia.org/wikipedia/commons/f/f2/Google_Pay_Logo.svg",
      type: "wallet",
    },
    {
      name: "Amazon Pay",
      logo: amazonPayLogo,
      type: "wallet",
    },
    {
      name: "Link",
      logo: linkLogo,
      type: "wallet",
    },
    {
      name: "Cash App",
      logo: cashAppLogo,
      type: "wallet",
    },
  ];

  return (
    <Box
      bg="white"
      py={{ base: 6, md: 8 }}
      borderY="1px solid"
      borderColor="gray.200"
      overflow="hidden"
      position="relative"
    >
      <Text
        textAlign="center"
        fontSize={{ base: "xs", md: "sm" }}
        fontWeight="600"
        color="gray.600"
        mb={4}
        textTransform="uppercase"
        letterSpacing="wider"
      >
        All Major Payment Methods Accepted
      </Text>

      <Marquee
        gradient={true}
        gradientColor="white"
        gradientWidth={80}
        speed={40}
        pauseOnHover={false}
      >
        {paymentMethods.map((method, index) => (
          <Box
            key={`${method.name}-${index}`}
            minW={
              method.type === "card"
                ? { base: "120px", md: "150px" }
                : { base: "80px", md: "100px" }
            }
            h={{ base: "60px", md: "70px" }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            bg="white"
            borderRadius="8px"
            p={3}
            mx={{ base: 8, md: 12 }}
          >
            <Image
              src={method.logo}
              alt={method.name}
              maxH={
                method.name === "Amazon Pay"
                  ? { base: "24px", md: "28px" }
                  : method.name === "Link"
                  ? { base: "20px", md: "24px" }
                  : "100%"
              }
              maxW="100%"
              objectFit="contain"
            />
          </Box>
        ))}
      </Marquee>
    </Box>
  );
};
